export interface FidelityDataInfo {
  availableBonus: number;
  availablePoints: number;
}
export interface FidelityOptions {
  points: number;
  value: number;
}

export const mockFidelityDataInfo: FidelityDataInfo = {
  availableBonus: 30.0,
  availablePoints: 4000
};

export const mockFidelityOptions: FidelityOptions[] = [
  { points: 1000, value: 30.0 },
  { points: 2000, value: 60.0 },
  { points: 3000, value: 90.0 },
  { points: 4000, value: 120.0 }
];
